export default __webpack_public_path__ + "static/media/krishnaket.3bf9bd7a.jpg";